import typeUtils from './typeUtils.js.es6';
import clone from 'fast-clone';

const helpers = {
    sort: function(arr){
        if(!Array.isArray(arr)){
            throw new TypeError('Invalid argument supplied to helpers.sort(). Argument expected to be of type: Array');
        }

        return arr.sort((a, b) => {
            let n1 = typeUtils.isString(a.name) ? a.name : '',
                n2 = typeUtils.isString(b.name) ? b.name : '',
                _compare = n1.toLowerCase().localeCompare(n2.toLowerCase());

            if(_compare === 0){
                return n1.localeCompare(n2);
            }

            return _compare;
        });
    },
    cloneObjectWithProps: function(source, props){
        if(!typeUtils.isObject(source)){
            throw new TypeError('Invalid argument supplied to helpers.cloneObjectWithProps(source, props).  Argument expected to be of type: Object');
        }

        let ri = clone(source);

        if(typeUtils.isDefined(props) && Array.isArray(props) && props.length > 0){
            let withProps = {};
            props.forEach(prop => {
                if(typeUtils.isString(prop)){
                    withProps[prop] = ri[prop];
                }
            });

            return withProps;
        }

        return ri;
    },
    removeEmptyKeys: function(obj){
        typeUtils.isObject(obj) && Object.keys(obj).forEach(key => {
            if(typeUtils.isString(obj[key]) && obj[key].trim().length === 0){
                delete obj[key];
            }
        });
    },
    truncateString: function(s, length = 48){
        if(typeUtils.isString(s) && s.length > length){
            return [s.slice(0, length), '...'].join('');
        }

        return s;
    }
};

export default helpers;